import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postPecanForms } from "../../redux/actions/pecanActions";

const HealthQuestionnaire = ({ appData, postPecanFormsFunc }) => {
  let initialData = {};
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  if (
    appData.pecanOnboarding &&
    appData.pecanOnboarding.forms &&
    appData.pecanOnboarding.forms.healthForm
  ) {
    initialData = {
      ...initialData,
      ...appData.pecanOnboarding.forms.healthForm,
    };
  }
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          The Company seeks to support colleagues in the workplace and look at
          adjustments that may be required due to a medical condition.
          Additional information made be required to assist this process from
          you, your Doctor or through an Occupational Health Advisor.
        </div>
      ),
    },
    Group0: {
      title: "Please describe your general state of health:",
      type: "radio",
      value: getVal("Group0"),
      radioOptions: ["Excellent", "Good", "Fair", "Poor", "Chronic"],
      mandatory: true,
    },
    blurb2: {
      htmlObj: (
        <div>
          Please indicate if you have any past or re-occuring problems
          associated with the following:
        </div>
      ),
    },
    Group1: {
      title:
        "Have you now or over the last 7 days suffered from sickness, diarrhoea, boils, septic fingers, discharge from your eye, ears or gums/mouth or have skin trouble affecting your hands, arms or face?",
      type: "checkbox",
      value: getVal("Group1"),
      mandatory: true,
    },
    Group2: {
      title:
        "Do you have a medical condition that is long standing or reoccurring in nature?",
      type: "checkbox",
      value: getVal("Group2"),
      mandatory: true,
    },
    Group3: {
      title:
        "Do you have any disabilities, or medical conditions that may affect your duties? e.g. mobility, hearing, visual, learning difficulties, mental health",
      type: "checkbox",
      value: getVal("Group3"),
      mandatory: true,
    },
    Group4: {
      title: (
        <Fragment>
          Are you currently taking any medicines, pills, tablets, inhalers
          <br /> or injections?
        </Fragment>
      ),
      type: "checkbox",
      value: getVal("Group4"),
      mandatory: true,
    },
    Group5: {
      title:
        "Are you under any other medical treatment or observation, including counselling?",
      type: "checkbox",
      value: getVal("Group5"),
      mandatory: true,
    },
    Group6: {
      title:
        "Do you have any health concerns that would put you at high risk from COVID19?",
      type: "checkbox",
      value: getVal("Group6"),
      mandatory: true,
    },
    Group7: {
      title:
        "Do you have any Heart problems e.g. angina, blood pressure, heart attacks, stroke?",
      type: "checkbox",
      value: getVal("Group7"),
      mandatory: true,
    },
    Group8: {
      title:
        "Do you have any Stomach or Bowel disorders e,g, peptic ulcer, irritable bowl, colitis?",
      type: "checkbox",
      value: getVal("Group8"),
      mandatory: true,
    },
    Group9: {
      title:
        "Do you have any Muscular or Skeletal problems e.g. back, arthritis, rheumatism?",
      type: "checkbox",
      value: getVal("Group9"),
      mandatory: true,
    },
    Group10: {
      title:
        "Do you have any Respiratory or lung disorder e.g. asthma, bronchitis, tuberculosis?",
      type: "checkbox",
      value: getVal("Group10"),
      mandatory: true,
    },
    Group11: {
      title:
        "Do you have any Circulation problems e.g. varicose veins, phlebitis, thrombosis?",
      type: "checkbox",
      value: getVal("Group11"),
      mandatory: true,
    },
    Group12: {
      title:
        "Do you have any Endocrine, gland or hormone problems e.g. diabetes, thyroid?",
      type: "checkbox",
      value: getVal("Group12"),
      mandatory: true,
    },
    Group13: {
      title: "Do you have any form of cancer, tumour or malignancy?",
      type: "checkbox",
      value: getVal("Group13"),
      mandatory: true,
    },
    Group14: {
      title: "Have you suffered from Epilepsy, blackouts or fainting attacks?",
      type: "checkbox",
      value: getVal("Group14"),
      mandatory: true,
    },
    Group15: {
      title:
        "Do you have any Vibration related problems or repetitive strain injury (RSI)?",
      type: "checkbox",
      value: getVal("Group15"),
      mandatory: true,
    },
    Group16: {
      title: "Do you suffer from Migraines or headaches?",
      type: "checkbox",
      value: getVal("Group16"),
      mandatory: true,
    },
    Group17: {
      title:
        "Have you had any injuries, operations, fractures affecting bones, muscles, tendons?",
      type: "checkbox",
      value: getVal("Group17"),
      mandatory: true,
    },
    Group18: {
      title:
        "Do you have any mental health problems e.g. anxiety, depression, stress?",
      type: "checkbox",
      value: getVal("Group18"),
      mandatory: true,
    },
    Group19: {
      title:
        "Do you have any bacterial infections, a carried of or in contact with typhoid/paratyphoid?",
      type: "checkbox",
      value: getVal("Group19"),
      mandatory: true,
    },
    Group20: {
      title:
        "Do you have any issues affecting eyes, ears or skin, specifically on hands, arms or face?",
      type: "checkbox",
      value: getVal("Group20"),
      mandatory: true,
    },
    Group21: {
      title: "Do you have any allergies or any form of colour deficiency?",
      type: "checkbox",
      value: getVal("Group21"),
      mandatory: true,
    },
    other: {
      title:
        "If you have answered yes or ticked any box above, please provide further details below:",
      type: "textarea",
      value: getVal("other"),
      mandatory: true,
      dependOnAny: [
        { fieldKey: "Group1" },
        { fieldKey: "Group2" },
        { fieldKey: "Group3" },
        { fieldKey: "Group4" },
        { fieldKey: "Group5" },
        { fieldKey: "Group6" },
        { fieldKey: "Group7" },
        { fieldKey: "Group8" },
        { fieldKey: "Group9" },
        { fieldKey: "Group10" },
        { fieldKey: "Group11" },
        { fieldKey: "Group12" },
        { fieldKey: "Group13" },
        { fieldKey: "Group14" },
        { fieldKey: "Group15" },
        { fieldKey: "Group16" },
        { fieldKey: "Group17" },
        { fieldKey: "Group18" },
        { fieldKey: "Group19" },
        { fieldKey: "Group20" },
        { fieldKey: "Group21" },
      ],
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postPecanFormsFunc("healthForm", {
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/onboarding-pecan");
  };

  return (
    <FormCreator
      formTitle={"Employee Health Questionnaire"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/onboarding-pecan")}
      onboardingBranch={"pecan"}
    />
  );
};
HealthQuestionnaire.propTypes = {
  appData: any,
  postPecanFormsFunc: func.isRequired,
};
const mapDispatchToProps = {
  postPecanFormsFunc: postPecanForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(HealthQuestionnaire);
